import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Recent Purchases"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-8" }, "My Transactions")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "Merchant"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Order"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-250px" }, "Product"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px rounded-end" }, "Actions")
  ])
], -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_8 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-8"
}
const _hoisted_9 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_10 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_11 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-8"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold text-muted d-block fs-8" }, "Paid", -1)
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-8"
}
const _hoisted_14 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "symbol symbol-50px me-5" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_19 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-8"
}
const _hoisted_20 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_21 = { class: "align-items-right" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Contact ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Cancel ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Refund")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Dispute ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsumerContactActions = _resolveComponent("ConsumerContactActions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ConsumerCancelActions = _resolveComponent("ConsumerCancelActions")!
  const _component_ConsumerDisputeActions = _resolveComponent("ConsumerDisputeActions")!
  const _component_ConsumerRefundDrawer = _resolveComponent("ConsumerRefundDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", _hoisted_8, _toDisplayString(item.product.name), 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.product.specs), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(item.product.phone), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", _hoisted_11, _toDisplayString(item.price), 1),
                    _hoisted_12
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", _hoisted_13, _toDisplayString(item.trial), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(item.producttype.order), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("img", {
                          src: item.product.image,
                          class: "",
                          alt: ""
                        }, null, 8, _hoisted_17)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("a", _hoisted_19, _toDisplayString(item.producttype.name), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.producttype.position), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_el_button, {
                        color: "#009ef7",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createVNode(_component_ConsumerContactActions)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        color: "#ffc700",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createVNode(_component_ConsumerCancelActions)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        color: "#ffc700",
                        id: "consumer_refund_drawer_toggle"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        color: "#3f4254",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _createVNode(_component_ConsumerDisputeActions)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_ConsumerRefundDrawer)
  ], 64))
}